export default __webpack_public_path__ + "static/media/bell-empty.1af639dc.svg";